import { Empty, List, Radio, Skeleton } from "antd";
import { chain } from "lodash";
import React from "react";
import { useIntl, FormattedMessage, defineMessage } from "react-intl";
import { FilterOutlined, SortAscendingOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { IPackage } from "../../../common/types";
import { Button, Select } from "../../atoms";
import { travelerTypeOptions } from "../../../enums";
import PackageItem from "./PackageItem";
import { PackageRequestForm } from "./PackageRequestForm";
const sortOptions = [
  {
    label: defineMessage({
      description: "Price Low to High",
      defaultMessage: "Price Low to High",
      id: "cVXf/g",
    }),
    value: "minPricePerAdult-asc",
  },
  {
    label: defineMessage({
      description: "Price High to Low",
      defaultMessage: "Price High to Low",
      id: "8cF34B",
    }),
    value: "minPricePerAdult-desc",
  },
  {
    label: defineMessage({
      description: "Travel Date Ascending",
      defaultMessage: "Travel Date Ascending",
      id: "jB/cqi",
    }),
    value: "departureDate-asc",
  },
  {
    label: defineMessage({
      description: "Travel Date Descending",
      defaultMessage: "Travel Date Descending",
      id: "O08693",
    }),
    value: "departureDate-desc",
  },
  {
    label: defineMessage({
      description: "Package Name A - Z",
      defaultMessage: "Package Name A - Z",
      id: "j0EK1D",
    }),
    value: "name-asc",
  },
  {
    label: defineMessage({
      description: "Package Name Z - A",
      defaultMessage: "Package Name Z - A",
      id: "OB23fp",
    }),
    value: "name-desc",
  },
];
type DiscountType = "pasydyDiscount" | "poedDiscount";
const discountFieldName = process.env.REACT_APP_SITE_DISCOUNT as DiscountType;

function calcPageCount(
  totalPackages: number,
  pageNumber: number,
  pageSize = 50,
): number {
  if (totalPackages === 0) return 0;

  const maxForPage = pageNumber * pageSize;
  return totalPackages < maxForPage ? totalPackages : maxForPage;
}
export interface IPackageItemListProps {
  travelPackages: IPackage[];
  sorting: any;
  isTabletOrMobile: boolean;
  isMobile: boolean;
  onShowFilter: () => void;
  onSort: (value: string) => void;
  partner?: string;
  totalPackages: number;
  setPage: (value: any) => void;
  loading: boolean;
  setInterest: (value: any) => void;
  interest: string;
  pageNumber: number;
}

export const PackageItemList: React.FC<IPackageItemListProps> = ({
  travelPackages,
  sorting,
  isTabletOrMobile,
  isMobile,
  onShowFilter,
  onSort,
  partner,
  totalPackages,
  setPage,
  loading,
  setInterest,
  interest,
  pageNumber,
}) => {
  const location = useLocation();
  const { formatMessage } = useIntl();
  const [currentPackages, setCurrentPackages] = React.useState<IPackage[]>([]);
  const [_showRequestForm, setShowRequestForm] = React.useState<boolean>(false);

  const handleChangeInterest = (value: any) => {
    setInterest(value?.target?.value || "");
  };
  const [discount] = React.useState<boolean>(false);
  const onLoadMore = () => {
    setPage((p: number) => +p + 1);
  };
  React.useEffect(() => {
    const defaultPackages = chain(travelPackages)
      .map((p: any) => {
        const dis = +(p?.[discountFieldName] || 0);
        const currentDiscount: number = Math.ceil(
          (+p.minPricePerAdult * +dis) / 100,
        );
        const currentPrice = +p.minPricePerAdult - +currentDiscount;
        return {
          ...p,
          minPricePerAdult: currentPrice,
        };
      })
      .value();
    setCurrentPackages(defaultPackages);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    setShowRequestForm(true);
  }, [location, sorting, travelPackages]);
  const loadMore = !loading ? (
    <div
      style={{
        textAlign: "center",
        marginTop: 12,
        height: 32,
        lineHeight: "32px",
      }}
    >
      <Button type="primary" onClick={onLoadMore}>
        Πατηστε για Περισσοτερα
      </Button>
    </div>
  ) : null;
  return (
    <div className="package-list-frontend-right">
      {discount && (
        <div className="package-list-frontend-discount-text">
          Προσφορά Μόνο για τη Black Friday! -10% σε όλα μας τα πακέτα{" "}
        </div>
      )}
      <div className="package-list-frontend-header">
        {isTabletOrMobile && (
          <div className="package-list-frontend-header-filter">
            <Button type="link" onClick={onShowFilter}>
              <FilterOutlined />
            </Button>
          </div>
        )}
        <div className="package-list-frontend-header-result">
          {" "}
          {calcPageCount(+totalPackages, +pageNumber, 50)} από{" "}
          {totalPackages || 0}{" "}
          <FormattedMessage
            description="Results"
            defaultMessage="Results"
            id="r1l+Iq"
          />
        </div>
        <div className="package-list-frontend-header-sorting">
          <span className="title">
            {!isMobile ? (
              <FormattedMessage
                description="Sorting"
                defaultMessage="Sorting"
                id="WwgJXV"
              />
            ) : (
              <SortAscendingOutlined />
            )}
          </span>
          <Select
            defaultValue="minPricePerAdult-asc"
            options={sortOptions.map((v) => ({
              label: formatMessage(v.label),
              value: v.value,
            }))}
            value={`${sorting.name}-${sorting.order}`}
            onChange={onSort}
          />
        </div>
      </div>

      <div className="package-list-frontend-result">
        <div className="package-list-frontend-interest">
          <span className="package-list-frontend-interest-title">
            {" "}
            Ταξιδιωτικές Προτάσεις
          </span>

          <Radio.Group
            options={travelerTypeOptions}
            onChange={handleChangeInterest}
            optionType={"button"}
          />
        </div>
        <List
          dataSource={currentPackages}
          loadMore={loadMore}
          renderItem={(tavelPackage: IPackage) => (
            <Skeleton loading={loading} active>
              <PackageItem
                key={tavelPackage?.id}
                travelPackage={tavelPackage}
                isMobile={isMobile}
                partner={partner}
                selectedInterest={interest}
              />
            </Skeleton>
          )}
          loading={loading}
          locale={{
            emptyText: (
              <Empty
                description={formatMessage({
                  description: "No packages available",
                  defaultMessage: "No packages available",
                  id: "OIjx77",
                })}
              >
                <PackageRequestForm isMobile={isMobile} />
              </Empty>
            ),
          }}
        />
      </div>
    </div>
  );
};
